import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import avtar from "../../assets/images/Profile-Picture.jpg";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

function MobileChatList() {
    const navigate = useNavigate();
  return (
    <div className='mainwrapperView'>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileMarketPlaceSeller")}
        />
        <h1>Chat List</h1>
      </div>
    <div className='ListingView'>
      <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileChatScreen')}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView'>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Product Name :</p>
            <p className='ListNameTxt'>ABCD ABCD</p>
        </div>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Price :</p>
            <p className='ListNameTxt'><CurrencyRupeeIcon sx={{fontSize:16}}/> 123.00</p>
        </div>
        </div>
        </div>
      </div>
      <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileChatScreen')}>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView'>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Product Name :</p>
            <p className='ListNameTxt'>ABCD ABCD</p>
        </div>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Price :</p>
            <p className='ListNameTxt'><CurrencyRupeeIcon sx={{fontSize:16}}/> 123.00</p>
        </div>
        </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default MobileChatList